import { Box, Button, Drawer, Theme } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { Close } from "@mui/icons-material";
import { FC, ReactNode } from "react";
import theme from "src/theme/light";

export interface IFIlterDrawer {
    open: boolean;
    onSearch: () => void;
    onClose?: () => void;
    onOpen?: () => void;
    anchor?: "left" | "right" | "top" | "bottom";
    children: ReactNode;
}

const styles = makeStyles((_theme: Theme) => ({
    FilterDrawer: {
        width: "286px",
        paddingBottom: "10px",
        zIndex: theme.zIndex.drawer + 3
    },
}));

const FilterDrawer: FC<IFIlterDrawer> = ({ open, anchor = "right", onSearch, onClose = () => { }, onOpen = () => { }, children }) => {
    const classes = styles();

    return <Drawer className={classes.FilterDrawer} open={open} anchor={anchor}>
        <Box paddingLeft={'10px'} paddingRight={'10px'} paddingBottom={"10px"}>
            <Button
                variant="text"
                color="primary"
                startIcon={<Close />}
                style={{ marginTop: 10, marginBottom: 50 }}
                onClick={() => { onClose() }}
            >
                Fechar
            </Button>
        </Box>
        <Box paddingLeft={'10px'} paddingRight={'10px'}>{children}</Box>
    </Drawer>
};

export { FilterDrawer };